import React, { Component} from "react";
import { withRouter } from 'react-router-dom';
import {
  Layout,  Card, SkeletonBodyText, Toast, EmptyState, BlockStack
} from "@shopify/polaris";
import {
  reqGetPartnerBannersList,
} from '../../../../api';

import SlideShow from "../../../../components/SlideShow";
import AppPartners from "../../../../components/AppPartners";

import "../index.css";
import intl from '../../../../i18n/intl';

class PartnersClass extends Component {
  state = {
    //弹窗
    showToast: false,  //弹窗显示
    showToastText:'',  //弹窗文字
    showToastIserror:false, //弹窗是否错误

    loadingBanner: true,
    bannerData: [],  // 轮播图

    loadingAppList: true,
    emptyOrErrorOnAppList: false,  // App推荐列表：没有数据或者请求报错
  };

  //进入页面调用接口
  componentDidMount () {
    this.getBannerList();
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  // 获取数据
  getBannerList = async () => {
    const params = {};
    const response = await reqGetPartnerBannersList(params)

    if (response.code === '200') {
      this.setState({
        loadingBanner: false,
        bannerData: response.data
      });
      
    } else {
      this.setState({
        loadingBanner: false,
      });
    }
  }

  // App列表请求回调
  AppListCallBack = (data) => {
    this.setState({
      loadingAppList: false,
      emptyOrErrorOnAppList: data.result
    });
  }

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;
    const {
      loadingBanner, bannerData, emptyOrErrorOnAppList
    } = this.state;

    // banner初始化页面
    const initBanenrSkeletonPage = (
      <div className="skeleton_page_children" style={{top:'40px'}}>
      <Layout>
          <Layout.Section>
          <BlockStack gap={400}>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
          </BlockStack>
        </Layout.Section>
          </Layout>
          </div>
    )

    // 页面空数据显示
    const EmptyContent = (!loadingBanner && emptyOrErrorOnAppList && bannerData.length === 0) && (
      <Card sectioned>
        <EmptyState
          heading="Best is being prepared..."
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>{intl.get("The good partners are coming soon.")}</p>
        </EmptyState>
      </Card>
    )

    /* 轮播图 */
    const bannerList = <SlideShow images={bannerData} round={true}/>

    /* App推荐列表 */
    const pageContent = (
       <Layout>
            <Layout.Section>
              {/* 轮播图 */}
              <div className="partner_silde">
              {bannerList}
              </div>
              {/* App推荐列表 */}
              {/* {loadingAppPartners} */}
              <AppPartners show={true} callBackFun={this.AppListCallBack} round={true}/>

              {/* 页面数据空时默认显示 */}
              {EmptyContent}
            </Layout.Section>
          </Layout>
    )

    return  (
      <div className="skeleton_page">
        {loadingBanner && initBanenrSkeletonPage}
         <div style={{opacity: loadingBanner ? 0 : 1}}>{pageContent}</div> 
        {toastMarkup}
      </div>
    );
  }
}

export default withRouter(PartnersClass);